var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-grid"},_vm._l((_vm.videos),function(video,index){return _c('VideoCard',{key:index,attrs:{"video":video}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }